import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/Login.vue'
import ChatView from '../views/ChatView.vue'
import HomeView from '../views/HomeView.vue'
import About from '../views/AboutView.vue'

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/ChatView',
    name: 'ChatView',
    component: ChatView
  },
  {
    path: '/About',
    name: 'About',
    component: About
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
